import React from 'react'
import { FormIdeaAnswer } from '.././styles'
import { FormAnswerProps } from '../contracts'

export const FormAnswerLink = ({ answer }: FormAnswerProps): JSX.Element => {
    const formattedLink = <a href={answer.value}>{answer.value}</a>
    return <FormIdeaAnswer>{formattedLink}</FormIdeaAnswer>
}
